require('./openYoungContactDataStep1.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText } = require('core/i18n').i18n;

// @components
const { HireContactDataForm } = require('components/hireContactDataForm/hireContactDataForm');

class OpenYoungContactDataStep1 extends React.Component {

    render() {
        const {immHireContactData} = this.props;
        return (
            <div className="open-young-contact-data-step-1">
                <FormattedText
                    className="open-young-contact-data-step-1__title"
                    value="openYoungContactData-openYoungContactData_titleStep1"
                />
                <HireContactDataForm
                    immHireContactData={immHireContactData}
                    prepopulate={false}
                />
            </div>
        );
    }

}

OpenYoungContactDataStep1.propTypes = {
    immHireContactData: PropTypes.object.isRequired,
};

module.exports = OpenYoungContactDataStep1;